var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "section",
      attrs: { id: "suspicious-login-admin-settings" }
    },
    [
      _c("h2", [
        _vm._v(_vm._s(_vm.t("suspicious_login", "Suspicious login detection")))
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n\t\t" +
            _vm._s(
              _vm.t(
                "suspicious_login",
                "The suspicious login app is enabled on this instance. It will keep track of IP addresses users successfully log in from and build a classifier that warns if a new login comes from a suspicious IP address."
              )
            ) +
            "\n\t"
        )
      ]),
      _vm._v(" "),
      _c("h3", [
        _vm._v(_vm._s(_vm.t("suspicious_login", "Training data statistics")))
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n\t\t" +
            _vm._s(
              _vm.t(
                "suspicious_login",
                "So far the app has captured {total} logins (including client connections), of which {distinct} are distinct (IP, UID) tuples.",
                {
                  total: _vm.stats.trainingDataStats.loginsCaptured,
                  distinct: _vm.stats.trainingDataStats.loginsAggregated
                }
              )
            ) +
            "\n\t"
        )
      ]),
      _vm._v(" "),
      _c("ModelPerformance", {
        attrs: {
          title: _vm.t("suspicious_login", "IPv4"),
          stats: _vm.stats,
          "address-type": "ipv4"
        }
      }),
      _vm._v(" "),
      _c("ModelPerformance", {
        attrs: {
          title: _vm.t("suspicious_login", "IPv6"),
          stats: _vm.stats,
          "address-type": "ipv6"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }